// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1_W4F","content":"LayoutSettings_content__2Koo8"};